import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FullViewService {
  private readonly isFullViewActive = signal<boolean>(false);
  readonly isFullView = this.isFullViewActive.asReadonly();

  enableFullView(): void {
    this.isFullViewActive.set(true);
  }

  disableFullView(): void {
    this.isFullViewActive.set(false);
  }
}